import { render } from "./etTable.vue?vue&type=template&id=83a2396c"
import script from "./etTable.vue?vue&type=script&lang=js"
export * from "./etTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__